'use client';
import { jsx } from 'react/jsx-runtime';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, n) {
    if (null == e) return {};
    var a, r, t = _object_without_properties_loose(e, n);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for(r = 0; r < o.length; r++)a = o[r], !(n.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(e, a) && (t[a] = e[a]);
    }
    return t;
}
function _object_without_properties_loose(e, n) {
    if (null == e) return {};
    var a, r, t = {}, o = Object.keys(e);
    for(r = 0; r < o.length; r++)a = o[r], n.indexOf(a) >= 0 || (t[a] = e[a]);
    return t;
}
const Banner = renderWithRef('Banner', null, (a, i)=>{
    useComponentStylesLoaded('Banner', SWAN_STYLE_KEY_MAP.banner), useDeprecatedProps('Banner', a, [
        {
            propName: 'textHorizontalAlignOnExtraSmall',
            instructions: 'The text will be by default center aligned on extra small screen size devices and to maintain the consistent user experience, we are deprecating this prop.'
        },
        {
            propName: 'imageFocalPoint',
            instructions: "This prop is deprecated and will be removed in a future release. Please set 'imageFocalPoint' on 'BannerImage' or 'BannerSecondaryImage' instead."
        }
    ]);
    let { children: l, height: s, textHorizontalAlignOnExtraSmall: d, textBoxHorizontalAlign: c = 'left', variant: m = 'card', twoImages: p = false, multiColumnOffer: f = false, withLeftHandNavigation: b = false, preferSecondaryImage: u = false, hideImageOnExtraSmall: g = false, editorial: w = false, imageFocalPoint: h } = a, x = _object_without_properties(a, [
        "children",
        "height",
        "textHorizontalAlignOnExtraSmall",
        "textBoxHorizontalAlign",
        "variant",
        "twoImages",
        "multiColumnOffer",
        "withLeftHandNavigation",
        "preferSecondaryImage",
        "hideImageOnExtraSmall",
        "editorial",
        "imageFocalPoint"
    ]), _ = new Set([
        'swan-banner'
    ]);
    return _.add(`swan-banner-${m}`), d && _.add(`swan-banner-text-horizontal-align-on-extra-small-${d}`), c && _.add(`swan-banner-text-box-horizontal-align-${c}`), 'short' === s && _.add('swan-banner-short'), p && 'card' === m && _.add('swan-banner-two-images'), f && _.add('swan-banner-multi-column-offer'), b && 'card' === m && 'left' === c && _.add('swan-banner-with-left-hand-navigation'), u && _.add('swan-banner-prefer-secondary-image'), g && _.add('swan-banner-hide-image-on-extra-small'), w && _.add("swan-banner-editorial"), h && _.add(`swan-banner-image-focal-point-${h.replace(/ +/g, '-')}`), jsx(RenderComp, {
        root: "div",
        forwardedRef: i,
        classNames: _,
        props: x,
        children: l
    });
});

export { Banner };
